export enum UnleashFlags {
  MY_AWESOME_FEATURE = "MY_AWESOME_FEATURE",
  TIME_TRACKING = "TIME_TRACKING"
}
